import { Box } from "@material-ui/core";
import FileDownloader from "../../../../CustomComponents/FileDownloadCGS";

const AttachmentPreview = ({ attachments }: { attachments?: any[] }) => {
  if (!attachments?.length) return null;

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {attachments?.map((file, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          width="100%"
          sx={{
            gap:'10px',
          }}
        >
          {/* File name */}
          <Box
            sx={{
              minWidth: "100px",   // 👈 key line
              flex: 1,         // allows expansion
              fontSize: "12px",
            }}
          >
            {file.file_name}
          </Box>
          <FileDownloader url={file.signed_url} />

        </Box>
      ))}
    </Box>
  );
};

export default AttachmentPreview;
